// Importing necessary modules
require('./bootstrap');
import { tns } from 'tiny-slider';

// Utility functions for class manipulation
const hasClass = (elem, className) => new RegExp(` ${className} `).test(` ${elem.className} `);

const addClass = (elem, className) => {
    if (!hasClass(elem, className)) {
        elem.className += ` ${className}`;
    }
};

const removeClass = (elem, className) => {
    const newClass = ` ${elem.className.replace(/[\t\r\n]/g, ' ')} `;
    if (hasClass(elem, className)) {
        elem.className = newClass.replace(new RegExp(` ${className} `, 'g'), ' ').trim();
    }
};

const toggleClass = (elem, className) => {
    hasClass(elem, className) ? removeClass(elem, className) : addClass(elem, className);
};

// Feature Test and Collapse Toggle
if ('querySelector' in document && 'addEventListener' in window && Array.prototype.forEach) {
    const toggleCollapse = (toggle) => {
        const dataID = toggle.getAttribute('data-target');
        const dataTarget = document.querySelector(dataID);

        toggleClass(toggle, 'active');
        toggleClass(dataTarget, 'active');
    };

    document.querySelectorAll('.collapse-toggle').forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            toggleCollapse(toggle);
        });
    });
}

// Change elements based on window width
if (jQuery(window).width() < 860) {
    $('p.single_paged-loc').appendTo('.copywrite_container');
}

// Load More functionality with AJAX
jQuery(() => {
    $('#true_loadmore').click(function () {
        $(this).text('Загружаю...');
        const data = {
            action: 'loadmore',
            query: true_posts,
            page: current_page
        };
        $.ajax({
            url: ajaxurl,
            data,
            type: 'POST',
            success: (response) => {
                if (response) {
                    $('#true_loadmore').text('Все игры');
                    $('.obj_row').before(response);
                    current_page++;
                    if (current_page === max_pages) {
                        $('#true_loadmore').remove();
                    }
                } else {
                    $('#true_loadmore').remove();
                }
            }
        });
    });
});

// Load Iframe Game functionality
(() => {
    'use strict';
    const wrap = document.getElementById('js_game');
    if (wrap) {
        const loadGame = () => {
            const btn = wrap.querySelector('button');
            if (btn) {
                btn.addEventListener('click', () => {
                    const frame = document.createElement('iframe');
                    frame.setAttribute('src', wrap.getAttribute('data-game'));
                    btn.removeEventListener('click', loadFrame);
                    wrap.innerHTML = '';
                    wrap.appendChild(frame);
                });
            }
        };
        loadGame();
    }
})();

// Initialize Tiny Slider
const mainSliderContainer = document.querySelector('.main-slider');
if (mainSliderContainer) {
    tns({
        container: mainSliderContainer,
        autoplay: true,
        controlsText: ['', ''],
        slideBy: 'page',
        freezable: false,
        autoplayButtonOutput: false
    });
}

// Accordion functionality
$(document).ready(() => {
    $('.accordion-wrapper__item .title').on('click', function () {
        const $this = $(this);
        const $accordionContent = $this.next();

        $('.accordion-content').slideUp();
        $('.accordion-wrapper__item .title').removeClass('open');

        if ($this.hasClass('open')) {
            $this.removeClass('open');
            $accordionContent.slideUp();
        } else {
            $this.addClass('open');
            $accordionContent.slideDown();
        }
        return false;
    });

    // Show/Hide mobile menu
    $('#showMenu').click(function () {
        $(this).toggleClass('open');
        $('.header-container-menu').animate({ width: 'toggle' });
    });
});
